var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathwayBreadcrumb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00439453 2.22578H5.45186V0.179688H6.81592V13.8203H5.45186V11.0922H2.72373V9.04609H5.45186V7.68203H1.35967V5.63594H5.45186V4.27188H-0.00439453V2.22578ZM8.17998 2.22578H10.2261V4.27188H8.17998V2.22578ZM8.17998 5.63594H11.5901V7.68203H8.17998V5.63594ZM8.17998 9.04609H13.6362V11.0922H8.17998V9.04609Z",
    fill: "#30CCE9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathwayBreadcrumb);
export default __webpack_public_path__ + "static/media/pathway-breadcrumb.b7c6def10ca1d4d4ff29d17f24e8ace6.svg";
export { ForwardRef as ReactComponent };